/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetRestrictionRequest} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/get_restriction.pb'
import {GetRestrictionResponse} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/get_restriction.pb'


export const getRestriction = (request: GetRestrictionRequest, options?: CashRequestOptions) => post<GetRestrictionRequest, GetRestrictionResponse>("/2.0/cash/get-restriction", request, {...options, rejectOnError: true })